import React from "react";
import {
  createFilters,
  getCellWidth,
  getFixedColumns,
  getFormattedTitles,
  getHiddenColumns,
  getSearchableColumns,
  getSorter,
} from "../../../utils/tableConfigs/GlobalFunctions";
import {
  COLUMN_WIDTHS,
  DEFAULT_HIDDEN_COLUMNS,
  FIXED_COLUMNS,
  SEARCHABLE_COLUMNS,
  TITLE_MAPPING,
  getTrialColumns,
} from "../../../utils/tableConfigs/DosingConstants";
import { getCellRenderer } from "../../../utils/tableConfigs/DosingFunctions";

export const getColumnConfig = (
  rows: Record<string, unknown>[],
  filteredInfo: Record<string, unknown[] | null>,
  singleview: boolean,
  trialId: string,
) => {
  if (!rows || rows.length === 0) return [];

  const availableHeaders = Object.keys(rows[0]);

  let headers: string[];

  if (singleview) {
    const ssjTrialColumns = getTrialColumns(trialId);
    headers = ssjTrialColumns.filter((header) =>
      availableHeaders.includes(header),
    );
  } else {
    headers = availableHeaders;
  }

  const columns = headers.map((header) => {
    const filters = createFilters(rows, header);
    return {
      title: () => getFormattedTitles(header, TITLE_MAPPING),
      dataIndex: header,
      key: header,
      sorter: getSorter(header),
      render: (text: unknown) => getCellRenderer(text as any, "float"),
      filters: filters,
      filteredValue: (() => {
        return filteredInfo[header] || null;
      })(),
      onFilter: (value: boolean | React.Key, record: Record<string, unknown>) =>
        record[header] === value,
      fixed: getFixedColumns(header, FIXED_COLUMNS),
      hidden: getHiddenColumns(header, DEFAULT_HIDDEN_COLUMNS),
      width: getCellWidth(header, COLUMN_WIDTHS),
      filterSearch: getSearchableColumns(header, SEARCHABLE_COLUMNS),
    };
  });

  return columns;
};
